<template>
  <v-navigation-drawer
    :value="value"
    @input="$emit('input', $event)"
    app
    color="dark"
    class="nav-drawer"
  >
    <v-list dense>
      <v-list-item class="justify-center">
        <img src="@/assets/images/holonative_logo.png" width="90%" class="my-3">
      </v-list-item>
      <v-divider class="my-2 mx-7" />
      <v-subheader class="mt-4 grey--text">ANGEBOTE</v-subheader>
      <v-list-item link to="/">
        <v-list-item-content>
          <v-list-item-title class="body-1 font-weight-regular">
            Living Images
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item link to="/posters">
        <v-list-item-content>
          <v-list-item-title class="body-1 font-weight-regular">
            AR-Filmposter
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-subheader class="grey--text mt-2">
        OPTIONEN
      </v-subheader>
       <!--  <v-list-item>
          <v-list-item-title>
            <v-switch
              v-model="options.console"
              label="Entwicklerkonsole"
              color="pink"
              hide-details
              class="mt-0 pa-3"
            />
          </v-list-item-title>
        </v-list-item> -->
      <v-list-item link download href="/downloads/holoNative_Living-Images-Marker.zip">
        <v-list-item-action>
          <v-icon>get_app</v-icon>
        </v-list-item-action>
        <v-list-item-content class="body-1 font-weight-regular">
          Marker herunterladen
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mb-3 mt-7 mx-7" />
      <v-list-item class="justify-center">
        <button
          class="modal-link mr-2"
          @click.stop="showContact = true"
        >
          Kontakt
        </button>
        <button
          class="modal-link"
          @click.stop="showLegal = true"
        >
          Impressum
        </button>
      </v-list-item>
      <v-list-item class="justify-center font-weight-light body-2">
        &copy; 2020 holoNative
      </v-list-item>
    </v-list>

    <modal-legal v-model="showLegal" />
    <modal-contact v-model="showContact" />
  </v-navigation-drawer>
</template>

<script>
import ModalLegal from '@/components/ModalLegal.vue'
import ModalContact from '@/components/ModalContact.vue'

export default {
  name: 'NavDrawer',
  components: {
    ModalLegal,
    ModalContact
  },
  props: { 
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showLegal: false,
      showContact: false,
      options: {
        console: false
      }
    }
  }
}
</script>

<style scoped>
.modal-link {
  color: #fff;
  padding: 5px;
}
.v-list-item__action:first-child,
.v-list-item__icon:first-child {
  margin-right: 16px !important;
}

/* #nav {
  padding: 30px;
}
#nav a {
  font-weight: bold;
  color: #2c3e50;
}
#nav a.router-link-exact-active {
  color: #42b983;
} */
</style>
